import React from 'react'

import ItemCard from '../itemCard'

const GridDefault = ({ items, viewType, currentSite, itemDecorator }) => {
  return (
    <ul data-test-selector="grid-layout" className="product-grid">
      {items.map((item, index) => {
        return (
          <li key={item.id}>
            <ItemCard
              currentSite={currentSite}
              viewType={viewType}
              itemProps={itemDecorator(item, index)}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default GridDefault



// WEBPACK FOOTER //
// ./client/components/productList/gridDefault.js